<span class="input-clear-border" fxLayout.xs="row" fxLayoutAlign="center">
    <input type="text" class="input-clear-text" [placeholder]="placeholder" [(ngModel)]="value" (ngModelChange)="emit()">
    <mat-icon class="input-clear-close" (click)="clear()">close</mat-icon>
</span>
